export interface IOTCInitRequest {
  email: string;
  amount: number;
  from: string;
  to: string;
  integrationId: string;
  operationType: string;
  customerType: string;
  fromBlockchain: string;
  toBlockchain: string;
}

export interface IOTCConvertRequest {
  from: string;
  to: string;
  amount: number;
  isReceiveCalculation: boolean;
}

export interface convertCurrencyRequest extends IOTCConvertRequest {
  keepOrdering: boolean;
}

export interface IOTCConvertResponse {
  data: number;
  timestamp: number;
  feePercent: number;
  rate: string;
  fromPrice: string;
  toPrice: string;
  keepOrdering: boolean;
}

export enum CustomerType {
  INDIVIDUAL = "INDIVIDUAL",
  BUSINESS = "BUSINESS",
}
export enum OperationType {
  FIAT_TO_CRYPTO = "FIAT_TO_CRYPTO",
  CRYPTO_TO_FIAT = "CRYPTO_TO_FIAT",
}

export enum OTCtype {
  FIAT_TO_CRYPTO_INDIVIDUAL = "FIAT_TO_CRYPTO_INDIVIDUAL",
  FIAT_TO_CRYPTO_BUSINESS = "FIAT_TO_CRYPTO_BUSINESS",
  CRYPTO_TO_FIAT_INDIVIDUAL = "CRYPTO_TO_FIAT_INDIVIDUAL",
  CRYPTO_TO_FIAT_BUSINESS = "CRYPTO_TO_FIAT_BUSINESS",
}

interface BaseSender {
  firstName: string;
  lastName: string;
  type: OTCtype;
}

interface IndividualSellCryptoSender extends BaseSender {
  walletAddress: string;
}
interface IndividualBuyCryptoSender extends BaseSender {}

type IndividualSender = IndividualBuyCryptoSender | IndividualSellCryptoSender;

interface BaseBusinessSender extends BaseSender {
  companyName: string;
  country: string;
  position: string;
  phoneNumber: string;
}

interface BusinessBuyCryptoSender extends BaseBusinessSender {}
interface BusinessSellCryptoSender extends BaseBusinessSender {
  walletAddress: string;
}

type BusinessSender = BusinessBuyCryptoSender | BusinessSellCryptoSender;

interface BaseResipient {
  firstName: string;
  lastName: string;
  type: OTCtype;
}

interface IndividualBuyCryptoRecipient extends BaseResipient {
  walletAddress: string;
}
interface IndividualSellCryptoRecipient extends BaseResipient {
  IBAN: string;
  residentialAddress: string;
}

type IndividualRecipient =
  | IndividualBuyCryptoRecipient
  | IndividualSellCryptoRecipient;

interface BaseBusinessRecipient extends BaseResipient {
  companyName: string;
  position: string;
  phoneNumber: string;
}
interface BusinessBuyCryptoRecipient extends BaseBusinessRecipient {
  walletAddress: string;
}
interface BusinessSellCryptoRecipient extends BaseBusinessRecipient {
  IBAN: string;
}
type BusinessRecipient =
  | BusinessBuyCryptoRecipient
  | BusinessSellCryptoRecipient;

export interface IOTCAcceptRequest {
  customerType: CustomerType;
  sender: IndividualSender | BusinessSender;
  operationType: OperationType;
  type: OTCtype;
  recipient: IndividualRecipient | BusinessRecipient;
}

export interface CurrencyAssetResponse {
  id: number;
  name: string;
  symbol: string;
  type: string;
  blockchain: string | null;
  maxAmount?: string;
  minAmount?: string;
}

export interface acceptOTCResponse {
  id: number;
  integrationId: string;
  customerType: string;
  email: string;
  sender: {
    firstName: string;
    lastName: string;
    companyName: null;
    country: string;
    position: string;
    phoneNumber: string;
    income: string;
    walletAddress: string;
    IBAN: string;
    residentialAddress: string;
  };
  recipient: {
    firstName: string;
    lastName: string;
    companyName: null;
    country: string;
    position: string;
    phoneNumber: string;
    typeOfActivity: string;
    income: string;
    walletAddress: string;
    IBAN: string;
    residentialAddress: string;
  };
  amount: string;
  convertedAmount: string;
  from: string;
  to: string;
  operationType: string;
  status: string;
  commentHistory: [];
  createdAt: string;
  client: {
    email: string;
    isKycVerified: boolean;
    id: string;
  };
  reportFile: {
    id: string;
    filename: string;
  };
  agreementFile: {
    id: string;
    filename: string;
  };
  cryptoTxs: [];
}

export interface IOTCStatusResponse {
  isKycKybVerified: boolean;
  needSof: boolean;
  currentStatus: string;
  needKycAddress: boolean;
}
